import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    FormControlLabel,
    Modal,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";


import { postBloodGroupDropdown, postDoctorDropdown, postIntraOperativeNotessaveOrUpdate, postgetAntibioticsDropdown } from "../../../services/otDetailsServices/OtDetailsServices";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import InputField from "../../../../common/components/FormFields/InputField";
import TimePickerFieldNew from "../../../../common/components/FormFields/TimePickerFieldNew";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { errorAlert, successAlert } from "../../../../common/components/Toasts/CustomToasts";
import DropdownField from "../../../../common/components/FormFields/DropdownField";

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function IntraOperativeNotesModel(props) {

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [patientData, setPatientData] = useState({});
    const [surgeonOptions, setSurgeonOptions] = useState([]);
    const [anesthetistOptions, setAnesthetistOptions] = useState([]);
    const [checkedByOptions, setCheckedByOptions] = useState([]);
    const [handoverToOptions, setHandoverToOptions] = useState([]);
    const [handoverByOptions, setHandoverByOptions] = useState([]);
    const [bloodGroupOptions, setBloodGroupOptions] = useState([]);

    const [isUpdate, setIsUpdate] = useState(false);

    const handleOpenPost = () => {
        setOpenPost(true);
    };
    const handleClosePost = () => {
        setOpenPost(false);
    };

    const defaultValues = {
        surgery: "",
        shiftOutOrder: null,
        anesthetist: null,
        anaesthesia: "",
        surgeryTime: null,
        recoveryShiftOutTime: null,
        surgicalSafetyChecklistDoneBy: "",
        checklistCompletionTime: null,
        cauterySite: "",
        skinIssue: "",
        antibiotic: "",
        remark: "",
        surgeryDone: "",
        allCountCorrect: "",
        signOutRemark: "",
        dressing: "",
        specimen: "",
        checkedBy: null,
        bloodGroup: null,
        bagNo: "",
        collectionDate: null,
        expiryDate: null,
        startTime: null,
        endTime: null,
        bloodProductRemark: "",
        handoverTo: null,
        handoverBy: null,
        handoverRemark: "",
    };

    const {
        control,
        watch,
        setValue,
        handleSubmit,
        getValues,
        reset,
    } = useForm({
        defaultValues,
    });

    const getBloodGroupDropdown = async () => {
        try {
            const response = await postBloodGroupDropdown("");

            console.log(
                "Blood Group API:",
                response.data.result
            );

            setBloodGroupOptions(
                response?.data?.result || []
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getCheckedByDropdown = async (value = "") => {
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setCheckedByOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getSurgeonDropdown = async (value = "") => {
        console.log("API Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);
            setSurgeonOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getAnesthetistDropdown = async (value = "") => {
        console.log("Anesthetist Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setAnesthetistOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };


    const getHandoverToDropdown = async (value = "") => {
        console.log("Handover To Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverToOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getHandoverByDropdown = async (value = "") => {
        console.log("Handover By Value:", value);
        if (!value?.trim()) return;

        try {
            const response = await postDoctorDropdown(value);

            setHandoverByOptions(response?.data?.result || []);
        } catch (error) {
            console.log(error);
        }
    };

    const handleSubmitClick = (data) => {
        setPendingData(data);
        setOpenPost(true);
    };

    const getTimePayload = (time) => {
        if (!time) return null;

        const timeObj = new Date(time);

        return `${String(timeObj.getHours()).padStart(2, "0")}:${String(
            timeObj.getMinutes()
        ).padStart(2, "0")}:${String(timeObj.getSeconds()).padStart(2, "0")}`;
    };

    const addRecord = async () => {
        try {
            setLoading(true);

            const data = pendingData;

            const collectionDateObj = data?.collectionDate
                ? new Date(data.collectionDate)
                : null;

            const expiryDateObj = data?.expiryDate
                ? new Date(data.expiryDate)
                : null;

            const payload = {
                id: isUpdate ? props.patientData?.id : null,
                admissionId: props?.admissionId || 0,
                otHeaderId: props?.otHeaderId || 0,
                surgery: data?.surgery || "",
                surgeon: data?.shiftOutOrder?.id || 0,
                anaesthetist: data?.anesthetist?.id || 0,
                anaesthesia: data?.anaesthesia || "",
                surgeryTime: getTimePayload(data?.surgeryTime),
                recoveryShiftOutTime: getTimePayload(data?.recoveryShiftOutTime),
                surgicalSafetyChecklistDoneBy:
                    data?.surgicalSafetyChecklistDoneBy || "",
                checklistCompletionTime:
                    getTimePayload(data?.checklistCompletionTime),
                cauterySite: data?.cauterySite || "",
                skinIssue: data?.skinIssue || "",
                antibiotic: data?.antibiotic || "",
                antibioticRemark: data?.remark || "",
                surgeryDone: data?.surgeryDone || "",
                allCountCorrect: data?.allCountCorrect || "",
                signOutRemark: data?.signOutRemark || "",
                dressing: data?.dressing || "",
                specimen: data?.specimen || "",
                checkedBy: data?.checkedBy?.id || 0,
                bloodGroup:
                    data?.bloodGroup?.label ||
                    data?.bloodGroup ||
                    "",
                bagNo: data?.bagNo || "",
                collectionDate: collectionDateObj
                    ? collectionDateObj.toISOString().split("T")[0]
                    : null,
                expiryDate: expiryDateObj
                    ? expiryDateObj.toISOString().split("T")[0]
                    : null,
                startTime: getTimePayload(data?.startTime),
                endTime: getTimePayload(data?.endTime),
                bloodProductRemark:
                    data?.bloodProductRemark || "",
                handoverTo: data?.handoverTo?.id || 0,
                handoverBy: data?.handoverBy?.id || 0,
                handoverRemark: data?.handoverRemark || "",

                ...(isUpdate
                    ? {
                        updatedBy: 1,
                        updatedDateTime: new Date().toISOString(),
                    }
                    : {
                        addedBy: 1,
                        addedDateTime: new Date().toISOString(),
                        updatedBy: 1,
                        updatedDateTime: new Date().toISOString(),
                    }),
            };

            console.log("PAYLOAD", payload);
            const response =
                await postIntraOperativeNotessaveOrUpdate(payload);

            successAlert(
                response?.data?.message || "Saved Successfully"
            );

            reset(defaultValues);

            handleClosePost();
            // props.handleClose();
        } catch (error) {
            errorAlert(
                error?.response?.data?.message ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.patientData) {
            setPatientData(props.patientData);
        }
    }, [props.patientData]);

    useEffect(() => {
        if (props.patientData?.id > 0) {
            setIsUpdate(true);

            reset({
                surgery: props.patientData?.surgery || "",
                shiftOutOrder: props.patientData?.surgeon
                    ? {
                        id: props.patientData.surgeonId,
                        label: props.patientData.surgeon,
                        value: props.patientData.surgeon,
                    }
                    : null,
                anesthetist: props.patientData?.anaesthetist
                    ? {
                        id: props.patientData.anaesthetistId,
                        label: props.patientData.anaesthetist,
                        value: props.patientData.anaesthetist,
                    }
                    : null,
                anaesthesia: props.patientData?.anaesthesia || "",
                surgicalSafetyChecklistDoneBy:
                    props.patientData?.surgicalSafetyChecklistDoneBy || "",
                surgeryTime: props.patientData?.surgeryTime
                    ? new Date(`2000-01-01T${props.patientData.surgeryTime}`)
                    : null,

                recoveryShiftOutTime: props.patientData?.recoveryShiftOutTime
                    ? new Date(
                        `2000-01-01T${props.patientData.recoveryShiftOutTime}`
                    )
                    : null,

                checklistCompletionTime:
                    props.patientData?.checklistCompletionTime
                        ? new Date(
                            `2000-01-01T${props.patientData.checklistCompletionTime}`
                        )
                        : null,
                cauterySite: props.patientData?.cauterySite || "",
                skinIssue: props.patientData?.skinIssue || "",
                remark: props.patientData?.antibioticRemark || "",
                surgeryDone: props.patientData?.surgeryDone || "",
                allCountCorrect: props.patientData?.allCountCorrect || "",
                signOutRemark: props.patientData?.signOutRemark || "",
                dressing: props.patientData?.dressing || "",
                specimen: props.patientData?.specimen || "",
                checkedBy: props.patientData?.checkedBy
                    ? {
                        id: props.patientData.checkedById,
                        label: props.patientData.checkedBy,
                        value: props.patientData.checkedBy,
                    }
                    : null,
                bloodGroup: null,
                bagNo: props.patientData?.bagNo || "",
                collectionDate: props.patientData?.collectionDate
                    ? new Date(props.patientData.collectionDate)
                    : null,
                expiryDate: props.patientData?.expiryDate
                    ? new Date(props.patientData.expiryDate)
                    : null,

                startTime: props.patientData?.startTime
                    ? new Date(`2000-01-01T${props.patientData.startTime}`)
                    : null,

                endTime: props.patientData?.endTime
                    ? new Date(`2000-01-01T${props.patientData.endTime}`)
                    : null,
                bloodProductRemark: props.patientData?.bloodProductRemark || "",
                handoverTo: props.patientData?.handoverTo
                    ? {
                        id: props.patientData.handoverToId,
                        label: props.patientData.handoverTo,
                        value: props.patientData.handoverTo,
                    }
                    : null,
                handoverBy: props.patientData?.handoverBy
                    ? {
                        id: props.patientData.handoverById,
                        label: props.patientData.handoverBy,
                        value: props.patientData.handoverBy,
                    }
                    : null,

                antibiotic:
                    props.patientData?.antibioticName || "",

                handoverRemark: props.patientData?.handoverRemark || "",
            });

        } else {
            setIsUpdate(false);
            reset(defaultValues);
        }
    }, [props.patientData]);

    useEffect(() => {
        getBloodGroupDropdown();
    }, []);

    useEffect(() => {
        if (
            props.patientData?.bloodGroup &&
            bloodGroupOptions.length > 0
        ) {
            const selectedBloodGroup =
                bloodGroupOptions.find(
                    item =>
                        item.label ===
                        props.patientData.bloodGroup
                );

            if (selectedBloodGroup) {
                setValue(
                    "bloodGroup",
                    selectedBloodGroup
                );
            }
        }
    }, [
        props.patientData?.bloodGroup,
        bloodGroupOptions,
        setValue,
    ]);


    return (
        <div>
            <Box
                sx={{
                    mt: 2,
                    p: 3,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    backgroundColor: "#fff",
                }}
            >

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adfde8] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Surgery Details
                        </div>

                        <div className="space-y-2 px-3 py-2">
                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Surgery
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Surgery"
                                    name="surgery"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">

                                <Typography fontWeight="600">
                                    Surgeon
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="shiftOutOrder"
                                    label="Shift Out Order By Surgeon"
                                    placeholder="Shift Out Order By Surgeon"
                                    options={surgeonOptions}
                                    isClearable={true}
                                    searchIcon={true}
                                    dataArray={surgeonOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        console.log("Surgeon:", value);
                                        getSurgeonDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />

                            </div>

                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Anaesthetist
                                </Typography>

                                <Typography>:</Typography>

                                <SearchDropdown
                                    control={control}
                                    name="anesthetist"
                                    label="Anesthetist"
                                    placeholder="Anesthetist"
                                    searchIcon={true}
                                    isClearable={true}
                                    options={anesthetistOptions}
                                    dataArray={anesthetistOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getAnesthetistDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Anaesthesia
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Anaesthesia"
                                    name="anaesthesia"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Surgery Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    label="Surgery Time"
                                    name="surgeryTime"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[215px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Recovery Shift Out Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    label="Recovery Shift Out Time"
                                    name="recoveryShiftOutTime"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ebfead] text-sm font-semibold px-4 py-2 rounded-t-md mb-1">
                            Surgical Safety Checklist
                        </div>

                        <div className="space-y-2 px-3 py-2">
                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Surgical Safety Checklist Done By
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Surgical Safety Checklist Done By"
                                    name="surgicalSafetyChecklistDoneBy"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Checklist Completion Time
                                </Typography>

                                <Typography>:</Typography>

                                <TimePickerFieldNew
                                    control={control}
                                    label="Checklist Completion Time"
                                    name="checklistCompletionTime"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />

                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Cautery Site
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Cautery Site"
                                    name="cauterySite"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Skin Issue
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Skin Issue"
                                    name="skinIssue"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>

                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#fec6d5] text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Antibiotic Details
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">
                                    Antibiotic
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    name="antibiotic"
                                    label="Antibiotic"
                                    size="small"
                                    fullWidth

                                />

                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Remark
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Remark"
                                    name="remark"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>


                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adebfe] text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Surgery Outcome
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Surgery Done
                                </Typography>

                                <Typography>:</Typography>

                                <RadioGroup
                                    row
                                    value={watch("surgeryDone")}
                                    onChange={(e) => setValue("surgeryDone", e.target.value)}
                                >
                                    <FormControlLabel
                                        value="Successful"
                                        control={<Radio />}
                                        label="Successful"
                                    />

                                    <FormControlLabel
                                        value="Abandoned"
                                        control={<Radio />}
                                        label="Abandoned"
                                    />

                                    <FormControlLabel
                                        value="NA"
                                        control={<Radio />}
                                        label="NA"
                                    />
                                </RadioGroup>
                            </div>

                        </div>
                    </div>

                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                    <div className="border rounded-md bg-white">
                        <div className="bg-[#ebfead] text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Sign Out
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    All Count Correct
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="All Count Correct"
                                    name="allCountCorrect"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Remark
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Remark"
                                    name="signOutRemark"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#fec0ad]  text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Additional Details
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Dressing
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Dressing"
                                    name="dressing"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">
                                    Specimen
                                </Typography>

                                <Typography>:</Typography>

                                <InputField
                                    control={control}
                                    label="Specimen"
                                    name="specimen"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                        </div>
                    </div>

                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#fc94af] text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Blood Products
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_minmax(0,1fr)] items-center gap-1">

                                <Typography fontWeight="600">Checked By</Typography>
                                <Typography>:</Typography>
                                <SearchDropdown
                                    control={control}
                                    name="checkedBy"
                                    label="Checked By"
                                    placeholder="Checked By"
                                    options={checkedByOptions}
                                    dataArray={checkedByOptions}
                                    searchIcon={true}
                                    isClearable={true}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getCheckedByDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">Blood Group</Typography>
                                <Typography>:</Typography>

                                <DropdownField
                                    control={control}
                                    name="bloodGroup"
                                    placeholder="Select Blood Group"
                                    label="Blood Group"
                                    options={bloodGroupOptions}
                                    dataArray={bloodGroupOptions}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Bag No</Typography>
                                <Typography>:</Typography>
                                <InputField
                                    control={control}
                                    name="bagNo"
                                    label="Bag No"
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Collection Date</Typography>
                                <Typography>:</Typography>
                                <DatePickerField
                                    control={control}
                                    name="collectionDate"
                                    label="Collection Date"
                                    inputFormat="dd-MM-yyyy"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Expiry Date</Typography>
                                <Typography>:</Typography>
                                <DatePickerField
                                    control={control}
                                    name="expiryDate"
                                    label="Expiry Date"
                                    inputFormat="dd-MM-yyyy"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">Start Time</Typography>
                                <Typography>:</Typography>
                                <TimePickerFieldNew
                                    control={control}
                                    name="startTime"
                                    label="Start Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-center gap-1">
                                <Typography fontWeight="600">End Time</Typography>
                                <Typography>:</Typography>
                                <TimePickerFieldNew
                                    control={control}
                                    name="endTime"
                                    label="End Time"
                                    textFieldProps={{
                                        size: "small",
                                        fullWidth: true,
                                    }}
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">Remark</Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="bloodProductRemark"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Remark"
                                            multiline
                                            rows={2}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </div>

                        </div>
                    </div>

                    <div className="border rounded-md bg-white">
                        <div className="bg-[#adfde8] text-sm font-semibold px-4 py-2 rounded-t-md mb-2">
                            Handover Details
                        </div>

                        <div className="space-y-2 px-3 py-2">

                            <div className="grid grid-cols-[220px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">Handover To</Typography>
                                <Typography>:</Typography>
                                <SearchDropdown
                                    control={control}
                                    name="handoverTo"
                                    label="Handover To"
                                    placeholder="Handover To"
                                    searchIcon={true}
                                    options={handoverToOptions}
                                    isClearable={true}
                                    dataArray={handoverToOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getHandoverToDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_minmax(0,1fr)] items-center gap-1">
                                <Typography fontWeight="600">Handover By</Typography>
                                <Typography>:</Typography>
                                <SearchDropdown
                                    control={control}
                                    name="handoverBy"
                                    label="Handover By"
                                    placeholder="Handover By"
                                    searchIcon={true}
                                    options={handoverByOptions}
                                    isClearable={true}
                                    dataArray={handoverByOptions}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                    handleInputChange={(value) => {
                                        getHandoverByDropdown(value);
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            <div className="grid grid-cols-[220px_20px_1fr] items-start gap-1">
                                <Typography fontWeight="600">Remark</Typography>
                                <Typography>:</Typography>

                                <Controller
                                    name="handoverRemark"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Remark"
                                            multiline
                                            rows={2}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </div>

                        </div>
                    </div>

                </div>

                <div className="flex justify-end gap-3 mt-6">
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() => reset()}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        Reset
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleSubmitClick)}
                        sx={{
                            backgroundColor: "#22c55e",
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: 500,
                            px: 2,
                            "&:hover": {
                                backgroundColor: "#16a34a",
                            },
                        }}
                    >
                        {isUpdate ? "Update" : "Submit"}
                    </Button>
                </div>

            </Box>


            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Confirm"
            />
        </div>
    );
}